import React, { Context, createContext, Dispatch, FC, ReactNode, useState } from "react";
import { ResultMessage } from "../../models/DTOs";

export interface NotificationContextHolder {
    lastResultMessage?: ResultMessage;
    setLastResultMessage: Dispatch<ResultMessage | undefined>;
}

export const NotificationContext: Context<NotificationContextHolder> =
    createContext({
        setLastResultMessage: (lastResultMessage: ResultMessage) => lastResultMessage,
    } as NotificationContextHolder);


interface Props {
    children?: ReactNode;
}

export const NotificationContextProvider: FC<Props> = ({
    children,
}) => {

    const [ lastResultMessage, setLastResultMessage ] = useState<ResultMessage>();

    return (
        <>
            <NotificationContext
                value={{
                    lastResultMessage,
                    setLastResultMessage,
                }}
            >
                {children}
            </NotificationContext>
        </>
    );
};